import {madnes_fill_range, madnes_set_sprite} from "../framework/src/engine/madnes/madnes";
import {madnes_set_default_volume} from "../framework/src/engine/madnes/madnes_audio";

var in_smoke_pos = 0;
var lines = new Array();

var render_move_per_sec = 16;		// Symbolu za sekundu

//render_move_per_sec = 0.5;

var render_move_per_sec_free = 16;	// Symbolu za sekundu ve free spinu

export var cylinder_pos = new Array();
cylinder_pos[0] = 124 + 176;
cylinder_pos[1] = 466 + 176;
cylinder_pos[2] = 806 + 176;

export var freepanelpos = 200;

export var icons = {
    "symbol_Bar": {
        stop: [0],
        anim: madnes_fill_range(0,13),//12),
        blur: [13]
    },
    "symbol_Bell": {
        stop: [0],
        anim: madnes_fill_range(0,13),//12),
        blur: [13]
    },
    "symbol_Dollar": {
        stop: [0],
        anim: madnes_fill_range(0,13),//12),
        blur: [13]
    },
    "symbol_Grapes": {
        stop: [0],
        anim: madnes_fill_range(0,13),//12),
        blur: [13]
    },
    "symbol_Cherry": {
        stop: [0],
        anim: madnes_fill_range(0,13),//12),
        blur: [13]
    },
    "symbol_Melon": {
        stop: [0],
        anim: madnes_fill_range(0,13),//12),
        blur: [13]
    },
    "symbol_Mystery": {
        stop: [0],
        anim: madnes_fill_range(0,13),//12),
        blur: [13]
    },
    "symbol_Orange": {
        stop: [0],
        anim: madnes_fill_range(0,13),//12),
        blur: [13]
    },
    "symbol_Plum": {
        stop: [0],
        anim: madnes_fill_range(0,13),//12),
        blur: [13]
    },
    "symbol_Wild": {
        stop: [0],
        anim: madnes_fill_range(0,13),//12),
        blur: [13]
    },
    "symbol_Seven": {
        stop: [0],
        anim: madnes_fill_range(0,24),
        blur: [25],
    }
}

export var icons_tmp = new Array();

export var symbols = new Array();
symbols[0] = -1;
symbols[1] = -1;
symbols[2] = -1;

export var last_symbol = new Array();
last_symbol[0] = -1;
last_symbol[1] = -1;
last_symbol[2] = -1;


var symbols_before_stop = 4;


var reels_lenghts = new Array();
var reels_pos = new Array();

var img_laoder;

var diry = new Array();

var smoke_manager, smoke_emitter;

function init_game(dname, cfg)
{
    // madnes_load_init("stars", cfg);
    //
    // madnes_set_page_bg(dname, imgsPath + "web/background.png");
    //
    // madnes_set_texture_version(9);

    // madnes_set_ico_size(352, 190);
    //
    // madnes_set_native_sceen_size(1280, 720);
    //
    // madnes_show_money_pos_y = he * 0.48;

    //madnes_set_on_rotate_click("button_click");

    // for(var i in to_load_audio)
    // {
    //     madnes_add_audio(i, to_load_audio[i]);
    // }
    //
    // for(var i in to_load_json)
    // {
    //     if(infotexts_languages.indexOf(lang) == -1)
    //     {
    //         to_load_json[i] = to_load_json[i].replace("{l}", def_lang);
    //     }
    //
    //     madnes_add_json(i, to_load_json[i]);
    // }
    //
    // for(var i in to_load)
    // {
    //     madnes_add_to_load(i, to_load[i]);
    // }
    //
    // for(var i in to_load_fonts)
    // {
    //     madnes_add_font_to_load(i, to_load_fonts[i]);
    // }

    madnes_set_sprite('_sprite', 352, 320);
    madnes_set_sprite('_blur', 352, 320);
    /*
    madnes_set_sprite('wing_left', 500, 900);
    madnes_set_sprite('wing_right', 500, 900);
    */

    madnes_set_sprite('wing_left', 250, 450);
    madnes_set_sprite('wing_right', 250, 450);

    madnes_set_default_volume(0.8);

    madnes_set_printdesk_function(stars_print_desk);
    madnes_set_updatedesk_function(stars_print_reels);
    madnes_set_rotate_function(stars_rotate_run);

    madnes_set_infomenu_init_function(stars_infomenu_init);
    madnes_set_infomenu_open_function(stars_infomenu_open);
    madnes_set_infomenu_close_function(stars_infomenu_close);
    madnes_set_infomenu_update_function(stars_infomenu_update);
    madnes_set_infomenu_left_function(stars_infomenu_left);
    madnes_set_infomenu_right_function(stars_infomenu_right);

    madnes_set_coin_values_init(function(currency)
    {
        if(currency == "PLN")
        {
            coin_values = [0.1, 1];
        }
        else
        {
            madnes_coin_values_init(currency);
        }
    });

    madnes_init(dname);
}


// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// !! Pouze pro dev ucely. Na produkci se muze odebrat.
// !! Prod mat server by nemel podporovat vynuceni vysledku ani v pripade ponechani.
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
var force_res = "";
function stars_freespins_force_start(el)
{
    force_res = "spins";
}
function stars_multiwin_force_start(el)
{
    force_res = "multiwin";
}
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
